import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, inject, isDevMode } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { UserService } from '@core/store/user/user.service';
import { RESPONSE } from '../../../express.tokens';
import { Observable } from 'rxjs/internal/Observable';
import { EMPTY, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { AmApiKeyService } from '@core/services/am-api-key.service';

const userData = {
  name: 'estimator.for.am@evo-jet.com',
  key: 'tasjet-0siwve-voRcuj'
}

@Injectable({ providedIn: 'root' })
export class HandingFunnelGuard  {
  private _router = inject(Router);
  private _userService = inject(UserService);
  private _res = inject(RESPONSE, { optional: true })!;
  private _platformId = inject(PLATFORM_ID);
  private amApiKey = inject(AmApiKeyService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
  }

  somethingWentWrong() {
    if (isPlatformServer(this._platformId)) {
      this._res.status(403);
    }

    this._router.navigate(['handling-quote-funnel-error']);
  }

  canActivate(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> {

    if (isPlatformServer(this._platformId)) {
      return of(true);
    } else {
      // 1) Ensure request came from APM (skip check in dev mode)
      if (!isDevMode() && document && !document?.referrer.includes('airplanemanager')) {
        this.amApiKey.disable();
        this._router.navigate(['login'], { queryParams: { apm: 'redirect_failed' } });
        return EMPTY;
      }

      // 2) Obtain API key via backend login, then enable it
      return this._userService
        .login({ username: userData.name, password: userData.key })
        .pipe(
          tap((apiKey) => this.amApiKey.enable(apiKey)),
          // 3) Backend validation via LegacyTokenAuthentication using enabled X-AUTH-TOKEN
          switchMap(() => this._userService.loadUser()),
          map((res) => !!res),
          catchError(() => {
            this.amApiKey.disable();
            this.somethingWentWrong();
            return EMPTY;
          })
        )
    }
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.canActivate(childRoute, state);
  }
}
